module.exports = __webpack_public_path__ + "static/media/uc-impro.be768e98.webp";